import { Badge } from "@/components/ui/badge";
import { motion, useReducedMotion } from "framer-motion";

export default function FounderCard({ founder, compact = false }) {
  const reduced = useReducedMotion();
  return (
    <motion.article
      initial={reduced ? false : { opacity: 0, y: 12 }}
      whileInView={reduced ? undefined : { opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
      data-testid={`founder-card-${founder.slug}`}
      className="bg-paper rounded-2xl border border-[rgba(74,63,57,0.10)] shadow-[0_10px_30px_rgba(31,26,23,0.05)] p-6 sm:p-8"
    >
      <div className="flex items-start gap-5">
        <FounderMedallion initials={founder.initials} slug={founder.slug} />
        <div className="flex-1 min-w-0">
          <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1">
            <h3 className="font-display text-2xl sm:text-3xl text-ink">{founder.name}</h3>
            <Badge
              variant="secondary"
              className="bg-[rgba(126,155,134,0.22)] text-moss border-0 font-medium"
            >
              {founder.experience}
            </Badge>
          </div>
          <p className="mt-1 text-sm text-ink-muted">{founder.role}</p>
        </div>
      </div>

      <p className="mt-5 text-ink leading-[1.75] text-[15px] sm:text-base max-w-prose">
        {founder.intro}
      </p>

      <div className="mt-5 flex flex-wrap gap-2">
        {founder.highlights.slice(0, compact ? 2 : founder.highlights.length).map((h) => (
          <span
            key={h}
            className="text-[12.5px] px-3 py-1.5 rounded-full bg-[rgba(200,106,74,0.10)] text-[#8a4128] border border-[rgba(200,106,74,0.18)]"
          >
            {h}
          </span>
        ))}
      </div>
    </motion.article>
  );
}

export function FounderMedallion({ initials, slug, photoUrl }) {
  const isAstha = slug === "astha-ahluwalia";
  return (
    <div
      aria-hidden="true"
      className="relative w-20 h-20 sm:w-24 sm:h-24 shrink-0 rounded-full flex items-center justify-center overflow-hidden ring-1 ring-[rgba(74,63,57,0.08)]"
      style={{
        background: isAstha
          ? "radial-gradient(circle at 30% 30%, #F2D7B6, #C86A4A 80%)"
          : "radial-gradient(circle at 30% 30%, #CFE0D3, #7E9B86 80%)",
      }}
    >
      {photoUrl ? (
        <img
          src={photoUrl}
          alt=""
          loading="lazy"
          referrerPolicy="no-referrer"
          className="absolute inset-0 w-full h-full object-cover"
          onError={(e) => {
            e.currentTarget.style.display = "none";
          }}
        />
      ) : (
        <>
          <svg className="absolute inset-0 w-full h-full opacity-25" viewBox="0 0 100 100">
            <path d="M10 70 Q 30 50 50 70 T 90 70" stroke="#FFFBF5" strokeWidth="2" fill="none" />
            <path d="M10 80 Q 30 60 50 80 T 90 80" stroke="#FFFBF5" strokeWidth="1.5" fill="none" />
          </svg>
          <span className="font-display text-2xl sm:text-3xl text-white drop-shadow-sm">
            {initials}
          </span>
        </>
      )}
    </div>
  );
}
